import React from 'react';
import { IconButton } from '@oneaudi/unified-web-alpha-components';
import styled from 'styled-components';
import { SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150 } from '@oneaudi/unified-web-alpha-common-v2';
import { device } from '../../app/styles/devices';

const ArrowsWrapper = styled.div`
  display: flex;
  width: fit-content;
  gap: ${SYS_SPACE_FIXED_100};
  @media ${device.laptop} {
    gap: ${SYS_SPACE_FIXED_150};
  }
`;

interface ArrowButtonsAlphaProps {
  goToNext: () => void;
  goToPrev: () => void;
}

const ArrowButtonsAlpha: React.FC<ArrowButtonsAlphaProps> = ({ goToNext, goToPrev }) => {
  return (
    <ArrowsWrapper>
      <IconButton
        aria-label="Previous offer"
        data-testid="prev-slide"
        onClick={goToPrev}
        icon="back"
        variant="secondary"
        size="sm"
      />
      <IconButton
        aria-label="Next offer"
        data-testid="next-slide"
        onClick={goToNext}
        icon="forward"
        variant="secondary"
        size="sm"
      />
    </ArrowsWrapper>
  );
};

export default ArrowButtonsAlpha;
